(function(){
  function initOne(root){
    if(!root||root.dataset.xrvInit==='1')return;
    root.dataset.xrvInit='1';
    var cardHost=root.querySelector('[data-xrv-cards]');
    if(!cardHost)return;
    var cards=Array.from(root.querySelectorAll('[data-xrv-review]'));
    var gallery=root.querySelector('[data-xrv-gallery]');
    var galleryWrap=root.querySelector('[data-xrv-gallery-wrap]');
    var empty=root.querySelector('[data-xrv-empty]');
    var noMatch=root.querySelector('[data-xrv-no-match]');
    var pagination=root.querySelector('[data-xrv-pagination]');
    var numbers=root.querySelector('[data-xrv-page-numbers]');
    var info=root.querySelector('[data-xrv-page-info]');
    var prev=root.querySelector('[data-xrv-prev]');
    var next=root.querySelector('[data-xrv-next]');
    var formDetails=root.querySelector('[data-xrv-review-form]');
    var pageSize=Math.min(8,Math.max(4,Number(root.dataset.xrvPageSize)||8));
    var currentPage=1,activeFilter='all',sortMode=root.dataset.xrvDefaultSort||'manual';
    var original=cards.map(function(card,index){return {card:card,index:index}});
    var counts=[0,0,0,0,0,0],sum=0;
    cards.forEach(function(card){var rating=Number(card.dataset.rating);if(rating>=1&&rating<=5){counts[rating]++;sum+=rating}});
    var total=cards.length;
    if(total){
      var summary=root.querySelector('[data-xrv-summary]');
      var breakdown=root.querySelector('[data-xrv-breakdown]');
      var toolbar=root.querySelector('[data-xrv-toolbar]');
      if(summary)summary.hidden=false;
      if(breakdown)breakdown.hidden=false;
      if(toolbar)toolbar.hidden=false;
      var average=(sum/total).toFixed(1);
      var avgNode=root.querySelector('[data-xrv-average]'),totalNode=root.querySelector('[data-xrv-count]');
      if(avgNode)avgNode.textContent=average;
      if(totalNode)totalNode.textContent=String(total);
      var fill=root.querySelector('[data-xrv-stars-fill]');
      if(fill)fill.style.width=((sum/total)*20)+'%';
      for(var n=1;n<=5;n++){
        var b=root.querySelector('[data-xrv-bar="'+n+'"]'),c=root.querySelector('[data-xrv-rating-count="'+n+'"]');
        if(b)b.style.width=(100*counts[n]/total)+'%';
        if(c)c.textContent=String(counts[n]);
      }
      var hero=document.querySelector('[data-xrv-hero-summary]');
      if(hero && root.dataset.xrvSample!=='true'){
        hero.hidden=false;
        var ratingNode=hero.querySelector('[data-xrv-hero-rating]'),countNode=hero.querySelector('[data-xrv-hero-count]'),heroFill=hero.querySelector('[data-xrv-hero-starfill]');
        if(ratingNode)ratingNode.textContent=average;
        if(countNode)countNode.textContent=total+' reviews';
        if(heroFill)heroFill.style.width=((sum/total)*20)+'%';
      }
    }else if(empty)empty.hidden=false;
    var photos=Array.from(root.querySelectorAll('.xrv__card-photos .xrv__photo-open, [data-xrv-extra-photo]'));
    photos.sort(function(a,b){return Number(a.dataset.xrvGalleryPosition||60)-Number(b.dataset.xrvGalleryPosition||60)});
    if(photos.length&&gallery){
      if(galleryWrap)galleryWrap.hidden=false;
      var photoCount=root.querySelector('[data-xrv-photo-count]');
      if(photoCount)photoCount.textContent='('+photos.length+')';
      var extraNote=root.querySelector('[data-xrv-gallery-note]');
      if(extraNote&&root.querySelector('[data-xrv-extra-photo]'))extraNote.hidden=false;
      photos.forEach(function(button){
        var clone=document.createElement('button');
        clone.type='button';clone.className='xrv__photo-open';
        clone.setAttribute('aria-label','Open customer photo');
        clone.dataset.xrvPhotoFull=button.dataset.xrvPhotoFull;
        clone.dataset.xrvGalleryPosition=button.dataset.xrvGalleryPosition||'60';
        clone.dataset.xrvPhotoAlt=button.dataset.xrvPhotoAlt||'Customer photo';
        if(button.hasAttribute('data-xrv-extra-photo'))clone.setAttribute('data-xrv-extra-photo','');
        var photo=button.querySelector('img');
        if(photo)clone.appendChild(photo.cloneNode(true));
        gallery.appendChild(clone);
      });
    }
    function matchingRows(){
      var filtered=original.filter(function(row){
        if(activeFilter==='photos')return row.card.dataset.photos==='true';
        if(activeFilter.indexOf('rating:')===0)return Number(row.card.dataset.rating)===Number(activeFilter.split(':')[1]);
        return true;
      });
      filtered.sort(function(a,b){
        if(sortMode==='manual')return a.index-b.index;
        if(sortMode==='highest')return Number(b.card.dataset.rating)-Number(a.card.dataset.rating)||a.index-b.index;
        if(sortMode==='lowest')return Number(a.card.dataset.rating)-Number(b.card.dataset.rating)||a.index-b.index;
        var da=Date.parse(a.card.dataset.date||'')||0,db=Date.parse(b.card.dataset.date||'')||0;
        return db-da||a.index-b.index;
      });
      return filtered;
    }
    function repaint(){
      var rows=matchingRows(),pages=Math.ceil(rows.length/pageSize);
      if(currentPage>pages)currentPage=Math.max(1,pages);
      original.forEach(function(row){row.card.hidden=true});
      rows.forEach(function(row){cardHost.appendChild(row.card)});
      rows.slice((currentPage-1)*pageSize,currentPage*pageSize).forEach(function(row){row.card.hidden=false});
      if(noMatch)noMatch.hidden=(rows.length>0||total===0);
      if(pagination)pagination.hidden=pages<=1;
      if(pages>1&&numbers){
        numbers.replaceChildren();
        for(var i=1;i<=pages;i++){
          var b=document.createElement('button');b.type='button';b.dataset.xrvPage=String(i);
          b.textContent=String(i);b.setAttribute('aria-label','Review page '+i);
          if(i===currentPage){b.className='is-active';b.setAttribute('aria-current','page')}
          numbers.appendChild(b);
        }
      }else if(numbers)numbers.replaceChildren();
      if(prev)prev.disabled=currentPage<=1;
      if(next)next.disabled=currentPage>=pages;
      if(info)info.textContent=rows.length?('Showing '+((currentPage-1)*pageSize+1)+'–'+Math.min(currentPage*pageSize,rows.length)+' of '+rows.length+' reviews'):'';
    }
    root.addEventListener('click',function(e){
      var photo=e.target.closest('[data-xrv-photo-full]');
      if(photo){
        var dlg=root.querySelector('[data-xrv-lightbox]'),img=dlg&&dlg.querySelector('[data-xrv-lightbox-image]');
        if(!dlg||!img)return;
        img.src=photo.dataset.xrvPhotoFull;img.alt=photo.dataset.xrvPhotoAlt||'Customer photo';
        if(typeof dlg.showModal==='function')dlg.showModal();
        return;
      }
      var filter=e.target.closest('[data-xrv-filter]');
      if(filter){
        activeFilter=filter.dataset.xrvFilter;currentPage=1;
        root.querySelectorAll('[data-xrv-filter]').forEach(function(b){b.classList.toggle('is-active',b===filter)});
        repaint();return;
      }
      var rating=e.target.closest('[data-xrv-rating]');
      if(rating){
        activeFilter='rating:'+rating.dataset.xrvRating;currentPage=1;
        root.querySelectorAll('[data-xrv-filter]').forEach(function(b){b.classList.remove('is-active')});
        repaint();return;
      }
      var scroll=e.target.closest('[data-xrv-gallery-scroll]');
      if(scroll&&gallery){gallery.scrollBy({left:Number(scroll.dataset.xrvGalleryScroll)*Math.min(480,gallery.clientWidth*.85),behavior:'smooth'});return}
      var page=e.target.closest('[data-xrv-page],[data-xrv-prev],[data-xrv-next]');
      if(page){
        if(page.hasAttribute('data-xrv-prev'))currentPage--;
        else if(page.hasAttribute('data-xrv-next'))currentPage++;
        else currentPage=Number(page.dataset.xrvPage)||1;
        repaint();
        root.querySelector('[data-xrv-toolbar]')?.scrollIntoView({behavior:'smooth',block:'start'});
        return;
      }
      if(e.target.closest('[data-xrv-open-form]')&&formDetails)formDetails.open=true;
    });
    var sort=root.querySelector('[data-xrv-sort]');
    if(sort){sort.value=sortMode;sort.addEventListener('change',function(){sortMode=this.value;currentPage=1;repaint()})}
    repaint();
    if(location.hash.indexOf('xrv-write-')===1&&formDetails)formDetails.open=true;
  }
  function init(scope){(scope||document).querySelectorAll('[data-xrv-root]').forEach(initOne)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});
  else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
